// Generated by CoffeeScript 1.10.0

/*
Module containing tag implementations.
 */

(function() {
  var CodeTag, ImgTag, ListItemTag, ListTag, QuoteTag, SimpleTag, Tag, URLTag, bbdom, isValidURL,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  bbdom = require('./bbdom');

  isValidURL = require("./htmlutil").isValidURL;


  /*
  A BBCode Tag.
  
  The Tag class is basically a BBNode factory - a class that can create BBNodes
  inside the parse tree.
  
  As such the tag class itself only handles receives events that create BBNodes.
  Once the BBNode is added and stuffed on the top of the stack, it receives
  further parse events until the parse is complete.
  
  The default Tag class can be given a BBNode class that will be instantiated
  whenever onStartTag is received. If the start tag has arguments, it will be
  assumed to be invalid and nothing will be added.
   */

  Tag = (function() {
    function Tag(nodeClass) {
      this.nodeClass = nodeClass;
    }


    /*
    Indicates that a tag for this tag class is starting. This method should create
    and return an appropriate BBNode that will handle the remaining parse events.
    If this tag cannot handle this event (for example, the arguments are invalid),
    it should return <code>null</code> in which case it will be converted into a
    corresponding text event and delivered to the current node.
    
    @param [TagEvent] event
      the start tag event
    @return [BBNode] either a new {BBNode} that provides the implementation of
      this tag or `null` if the event cannot be used to create a {BBNode}
     */

    Tag.prototype.onStartTag = function(event) {
      if (event.arg != null) {
        return null;
      } else {
        return new this.nodeClass();
      }
    };

    return Tag;

  })();


  /*
  A very simple implementation of a tag. This works with any tag that is of the
  form `[tag]Contents[/tag]`. It allows other tags to be nested within them and
  simply surrounds its contents with the given starting and ending HTML.
   */

  SimpleTag = (function(superClass) {
    extend(SimpleTag, superClass);


    /*
    Create a new SimpleTag.
    @overload constructor(htmlElement)
      @param [String] htmlElement
        the name of the HTML element. This is automatically surrounded with `<`
        and `>`: it's the same as calling the two argument caller with
        `"<#{htmlElement}>", "</#{htmlElement}>"`.
    @overload constructor(htmlStart, htmlEnd)
      @param [String] htmlStart
        the HTML to replace the start tag with
      @param [String] htmlEnd
        the HTML to replace the end tag with
    @overload constructor()
      You may, optionally, not pass in any HTML to use. In this case, the start
      and ending HTML is simply blank.
     */

    function SimpleTag(htmlStart, htmlEnd) {
      SimpleTag.__super__.constructor.call(this);
      if (htmlEnd != null) {
        this.htmlStart = htmlStart;
        this.htmlEnd = htmlEnd;
      } else if (htmlStart != null) {
        this.htmlStart = "<" + htmlStart + ">";
        this.htmlEnd = "</" + htmlStart + ">";
      } else {
        this.htmlStart = "";
        this.htmlEnd = "";
      }
    }


    /*
    Returns `null` if the event has an argument.
    @param [TagEvent] event
      the event
    @return [BBElement] either a new {BBElement} with the starting and ending
      HTML for this node or `null` if there was an argument in the start tag
     */

    SimpleTag.prototype.onStartTag = function(event) {
      if (event.arg != null) {
        return null;
      } else {
        return new bbdom.BBElement(this.htmlStart, this.htmlEnd);
      }
    };

    return SimpleTag;

  })(Tag);


  /*
  Implementation of the `[url]` tag.
   */

  URLTag = (function(superClass) {
    extend(URLTag, superClass);


    /*
    Construct a new URLTag.
     */

    function URLTag() {
      URLTag.__super__.constructor.call(this, null);
    }


    /*
    Start a new `[url]` tag. If given an argument, returns `null` if the URL isn't
    "valid" as determined by {htmlutil~isValidURL}. Otherwise returns a new
    {BBURLElement}.
    
    @param [TagEvent] event
      the open tag event
    @return [BBURLElement]
      the new `[url]` element or `null` if the argument was rejected
     */

    URLTag.prototype.onStartTag = function(event) {
      if (event.arg != null) {
        if (isValidURL(event.arg)) {
          return new bbdom.BBURLElement(event.raw, event.arg);
        } else {
          return null;
        }
      } else {
        return new bbdom.BBURLElement(event.raw);
      }
    };

    return URLTag;

  })(Tag);


  /*
  Implementation of the `[img]` tag.
   */

  ImgTag = (function(superClass) {
    extend(ImgTag, superClass);


    /*
    Construct a new ImgTag.
     */

    function ImgTag() {
      ImgTag.__super__.constructor.call(this, null);
    }


    /*
    Start a new `[img]` tag - `[img]` tags do not accept arguments so this returns
    `null` if there is an argument.
    
    @param [TagEvent] event
      the open tag event
    @return [BBImgElement]
      the new `[img]` element or `null` if the tag had an argument
     */

    ImgTag.prototype.onStartTag = function(event) {
      if (event.arg != null) {
        return null;
      } else {
        return new bbdom.BBImgElement(event.raw);
      }
    };

    return ImgTag;

  })(Tag);

  QuoteTag = (function(superClass) {
    extend(QuoteTag, superClass);

    function QuoteTag() {
      QuoteTag.__super__.constructor.call(this, null);
    }

    QuoteTag.prototype.onStartTag = function(event) {
      return new bbdom.BBQuoteElement(event.arg);
    };

    return QuoteTag;

  })(Tag);

  CodeTag = (function(superClass) {
    extend(CodeTag, superClass);

    function CodeTag() {
      CodeTag.__super__.constructor.call(this, null);
    }

    CodeTag.prototype.onStartTag = function(event) {
      return new bbdom.BBCodeElement(event.raw);
    };

    return CodeTag;

  })(Tag);

  ListTag = (function(superClass) {
    extend(ListTag, superClass);

    function ListTag() {
      ListTag.__super__.constructor.call(this);
    }

    ListTag.prototype.onStartTag = function(event) {
      if (event.arg != null) {
        if (event.arg in bbdom.BBListElement.ALLOWED_TYPES) {
          return new bbdom.BBListElement(event.arg);
        } else {
          console.log("Invalid list type [" + event.arg + "]");
          return null;
        }
      } else {
        return new bbdom.BBListElement();
      }
    };

    return ListTag;

  })(Tag);

  ListItemTag = (function(superClass) {
    extend(ListItemTag, superClass);

    function ListItemTag() {
      ListItemTag.__super__.constructor.call(this, "li");
    }

    ListItemTag.prototype.onStartTag = function(event) {
      if (event.state.isParentTag("list")) {
        return new bbdom.BBListItemElement();
      } else if (event.state.isParentTags("*", "list")) {

      } else {
        return null;
      }
    };

    return ListItemTag;

  })(Tag);

  exports.Tag = Tag;

  exports.SimpleTag = SimpleTag;

  exports.URLTag = URLTag;

  exports.ImgTag = ImgTag;

  exports.QuoteTag = QuoteTag;

  exports.CodeTag = CodeTag;

  exports.ListTag = ListTag;

  exports.ListItemTag = ListItemTag;

}).call(this);



/*****************
 ** WEBPACK FOOTER
 ** ./~/bitter-bbcode/lib/tags.js
 ** module id = ./node_modules/bitter-bbcode/lib/tags.js
 ** module chunks = 1
 **/